import { Component } from 'preact'

import { api } from 'app/util/api'
import { Link } from 'preact-router'

export default class Tag extends Component {
  state = {
    tags: [],
  }

  componentDidMount() {
    this.findTags()
  }

  findTags = async () => {
    const tags = await api.get('/tag')

    this.setState({ tags })
  }

  renderList() {
    const { tags } = this.state

    return tags.map(tag => (
      <div class="row">
        <div class="col my-2">
          <Link class="text-dark mr-2" href={`/tags/${tag.name}`}>
            {tag.name}
          </Link>
          ({tag.count})
        </div>
      </div>
    ))
  }

  render() {
    const { tags } = this.state

    return (
      <div>
        {/* <h3>Tags</h3> */}
        <h2 class="font-weight-bold">Tags</h2>

        <div class="mb-4 text-muted">{tags.length > 0 ? `${tags.length} tags found` : null}</div>

        {this.renderList()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./pages/Tags.js